import Positions from "./Positions";
import User from "./items/User";
import {Ilayer, Imap} from "./Config";
import ArrayTools from "../../lib/array/ArrayTools";

interface ICindUserInStageCb{
	(item:any):boolean;
}

export class Family extends Positions{

    private lastXPosition:number;
    private lastWidth:number;
	private lastLevelIndex:number;
	private modifierNextItem:number;
	private treeLengths:any;


	constructor(default_url:string, url:string) {
		super(default_url, url);
        this.lastXPosition = 0;
        this.lastWidth = 0;
		this.modifierNextItem = 0;
		this.lastLevelIndex = null;
		this.treeLengths = {};
	}


	protected sortFamily(map:Imap){
		var temp:Array<Ilayer> 	= this.sortFamilyByBrothers(map.layers);
		temp 					= this.sortFamilyByCouple(temp);
		temp 					= this.sortFamilyByCommonChildrenParents(temp);
		temp 					= this.sortFamilyChidrenFromParentPosition(temp);
		map.layers = temp;
		return map;
	}

	protected setLevelIndex(currentItem:Ilayer):void{
		// parents
        if (  currentItem === undefined ) {
            console.error(currentItem);
            return;
        }
		if ( currentItem.fatherId !== null ) {
			this.findUser(currentItem.fatherId, (item:Ilayer)=>{
				if ( item.levelIndex === null ) {
					item.levelIndex = currentItem.levelIndex - 1;
					this.setLevelIndex(item);
				}
				return item;
			});
		}
		if ( currentItem.motherId !== null ) {
			this.findUser(currentItem.fatherId, (item:Ilayer)=>{
				if ( item.levelIndex === null ) {
					item.levelIndex = currentItem.levelIndex - 1;
					this.setLevelIndex(item);
				}
				return item;
			});
		}
		// childrens
		if ( currentItem.childrensIds !== null && currentItem.childrensIds.length > 0  ) {
			this.findUser(currentItem.childrensIds, (item:Ilayer)=>{
				if ( item.levelIndex === null ) {
					item.levelIndex = currentItem.levelIndex + 1;
					this.setLevelIndex(item);
				}
				return item;
			});
		}
		// bothers and brothers couples
		var brothersAndCouplesIds:Array<number> = currentItem.allBrothers;
		brothersAndCouplesIds = brothersAndCouplesIds.concat(currentItem.couplesIds);
		this.findUser(brothersAndCouplesIds, (item:Ilayer)=>{
			if ( item.levelIndex === null ) {
				item.levelIndex = currentItem.levelIndex;
				this.setLevelIndex(item);
			}
			return item;
		});
	}

	protected getStartItem():Ilayer{
		for (var key in this.map.layers) {
			var item = this.map.layers[key];
			if (item.properties !== undefined) {
				if (item.properties.type !== undefined) {
					if ( item.visible === true ) {
                        console.log('start item', item);
                        item.levelIndex = 0;
						return item;
					}
				}
			}
		}
	}

	private sortFamilyChidrenFromParentPosition(layers:Array<Ilayer>){
        //get childrens posiitons
        // sort by levelIndex
        var min:number = null;
        var max:number = null;
        var tempSorter:any = {};
        for (var key in layers) {
		    var item = layers[key];
            if ( min === null || min > item.levelIndex ) {
                min = item.levelIndex;
            }
            if ( max === null || max < item.levelIndex ) {
                max = item.levelIndex;
            }
            if (  tempSorter[item.levelIndex] === undefined ) {
                tempSorter[item.levelIndex] = [];
            }
            tempSorter[item.levelIndex].push(item as Ilayer);
        }
        var ret:Array<Ilayer> = [];
        var addedIds:Array<number> = [];
        for (let i = min; i <= max; i++) {
            for (var ikey in tempSorter[i]) {
                var iitem = tempSorter[i][ikey] as Ilayer;
                //first add this tree
                if ( iitem.levelId === undefined ) {
                    console.log(iitem, 'continue');
                    continue;
                }
                if ( iitem.levelIndex >= 0 && iitem.levelId !== null && iitem.levelId.indexOf('SZ1T2') === 0 ) {
                    if ( addedIds.indexOf(iitem.id) === -1 ) {
                        ret.push(iitem);
                        addedIds.push(iitem.id);
                    }
                }
            }
            for (var tkey in tempSorter[i]) {
                var titem = tempSorter[i][tkey] as Ilayer;
                if ( addedIds.indexOf(titem.id) === -1 ) {
                    ret.push(titem);
                    addedIds.push(titem.id);
                }
            }
        }
        return ret;
    }

    private getItemIndexInLayers(id:number):number{
        for (var key in this.map.layers) {
		    var item = this.map.layers[key];
            if ( item.id === id ) {
                return parseInt(key);
            }
        }
        return null;
    }

	private sortFamilyByCommonChildrenParents(layers:Array<Ilayer>):Array<Ilayer>{
		var temp:Array<Ilayer> = [];
		var addedIds:Array<number> = [];
		for (var key in layers) {
		    var item = layers[key];
			if ( addedIds.indexOf(item.id) === -1 ) {
				temp.push(item);
				addedIds.push(item.id);
				this.findUser(item.childrensIds, (childrenItem:Ilayer)=>{
					if ( childrenItem.motherId === item.id ) {
						if ( childrenItem.fatherId !== null && childrenItem.fatherId !== item.id && addedIds.indexOf(childrenItem.fatherId) === -1  ) {
							this.findUser(childrenItem.fatherId, (parentItem:Ilayer)=>{
                                if ( addedIds.indexOf(childrenItem.id) === -1  ) {
                                    temp.push(childrenItem);
                                    addedIds.push(childrenItem.id);
                                }
								return parentItem;
							});
						}
					}else if (childrenItem.fatherId === item.id) {
						if ( childrenItem.motherId !== null && childrenItem.motherId !== item.id && addedIds.indexOf(childrenItem.motherId) === -1  ) {
							this.findUser(childrenItem.motherId, (parentItem:Ilayer)=>{
                                if ( addedIds.indexOf(childrenItem.id) === -1  ) {
    								temp.push(childrenItem);
    								addedIds.push(childrenItem.id);
                                }
								return parentItem;
							});
						}
					}

					return childrenItem;
				});
			}
		}
		return temp;
	}

	private sortFamilyByCouple(layers:Array<Ilayer>):Array<Ilayer>{
		var temp:Array<Ilayer> = [];
		var addedIds:Array<number> = [];
		for (var key in layers) {
		    var item = layers[key];
			if ( addedIds.indexOf(item.id) === -1 ) {
				temp.push(item);
				addedIds.push(item.id);
				this.findUser(item.couplesIds, (coupleItem:Ilayer)=>{
					if ( addedIds.indexOf(coupleItem.id) === -1 ) {
						temp.push(coupleItem);
						addedIds.push(coupleItem.id);
					}
					return coupleItem;
				});
			}
		}
		return temp;
	}

	private sortFamilyByBrothers(layers:Array<Ilayer>):Array<Ilayer>{
		var temp:Array<Ilayer> = [];
		var addedIds:Array<number> = [];
		for (var key in layers) {
		    var item = layers[key];
			if ( addedIds.indexOf(item.id) === -1 ) {
                if ( item.sex === 'female' ) {
                    temp.push(item);
    				addedIds.push(item.id);
                }
				this.findUser(item.allBrothers, (brotherItem:Ilayer)=>{
					if ( addedIds.indexOf(brotherItem.id) === -1 ) {
						temp.push(brotherItem);
						addedIds.push(brotherItem.id);
                        this.findUser(brotherItem.childrensIds, (brotherChildrens:Ilayer)=>{
                            // gyerekeket is előre tolja
                            if ( addedIds.indexOf(brotherChildrens.id) === -1 ) {
                                temp.push(brotherChildrens);
                                addedIds.push(brotherChildrens.id);
                            }
                            return brotherChildrens;
                        });
					}
					return brotherItem;
				});
                if ( item.sex === 'male' ) {
    				temp.push(item);
    				addedIds.push(item.id);
                }
			}
		}
		return temp;
	}

	private setTreeItemNumber(levelId:string):void{
		if ( this.treeLengths[levelId] === undefined ) {
			var max : number = 0;
			for (var key in this.map.layers) {
				var item = this.map.layers[key];
				if (item.levelId !== null && item.levelId.indexOf(levelId) === 0) {
					++max;
				}
			}
			this.treeLengths[levelId] = max;
		}
	}

	private getTreeItemNumber(levelId : string) : number {
		if (this.treeLengths[levelId] !== undefined) {
			return this.treeLengths[levelId];
		}else{
            this.setTreeItemNumber(levelId);
            return this.getTreeItemNumber(levelId);
        }
	}

	protected addMapItem(item : Ilayer, index : number, isCoupleWithoutChildren : boolean, returnX:boolean=false) : number {
        var xPos:number = null;
		var id = item.id;
		if ( item.id_key !== undefined ) {
			id = item.id_key;
		}
    	var name = '_box_'+id;
		if ( this.addedIdsInStage.indexOf(id) === -1 ) {
			//just onece add one item
			var img = <HTMLImageElement>this.preload.getResult("profileImg_" + id);
			if ( img === null ) {
				img = <HTMLImageElement>this.preload.getResult("profileImg");
			}

	        this.current_map.item[name]        = new User(
				id,
				isCoupleWithoutChildren,
				img,
				item.lastName + ' ' + item.firstName,
				item.birthName,
				item.birthDate,
                item.levelId,
                item.itemNumber,
				(t) => {
					// NOTE: családváltás helye
					var url = '/csaladfa/' + t.id_key;
					// window.open(url, '_blank');
                    // if ( t.otherFamily === true ) {
                    //     console.log('Change to other family view', t.lastName, t.firstName);
                    // }
				}
			);
			this.current_map.item[name].fatherId     = item.fatherId;
			this.current_map.item[name].motherId     = item.motherId;
			this.current_map.item[name].childrensIds = item.childrensIds;
			this.current_map.item[name].couplesIds   = item.couplesIds;
			this.current_map.item[name].levelIndex   = item.levelIndex;
			this.current_map.item[name].otherFamily  = item.otherFamily;

			this.current_map.item[name].allBrothers  = item.allBrothers;
			item.width                               = this.current_map.item[name].width;
			item.height                              = this.current_map.item[name].height;
			this.current_map.item[name].id_key       = id;
	        this.current_map.item[name].name         = name;

			var startX:number                        = this.canvas.width / 2 - this.current_map.item[name].width / 2;
			var startY:number                        = this.canvas.height / 2 - this.current_map.item[name].height / 2;

            // console.log(item.levelIndex, item.lastName + ' ' + item.firstName, index);
	        // this.current_map.item[name].x            = startX + this.boxvHorisontalDistance * index;
            var lastXPosition = this.lastXPosition;
            var lastWidth = this.lastWidth;
            if (  item.levelIndex !== this.lastLevelIndex ) {
                lastXPosition = 0;
                lastWidth = 0;
            }
            this.lastLevelIndex = item.levelIndex;
            var itemNumber = item.itemNumber;
            if ( itemNumber > 1 ) {
                // NOTE: my fix, szerintem jobb mint Jani számolása
                -- itemNumber;
			}


			var modifier = this.modifierNextItem;
			if ( lastXPosition === 0) {
                modifier = 0;
                if ( this.getTreeItemNumber('SZ1T2') > 0 ) {
                    if (item.levelIndex <= -2 ) {
                        // first item in row to top
    					// NOTE: i hope its good
    					modifier = this.getTreeItemNumber('SZ1T2') - 1 + 0.5;
                    }
                }

			}else{
                // other items
                if ( item.levelId !== null ) {
    				if (item.levelId.indexOf('SZ1T2') === 0 ){
                        // baloldalsó unokatestvér
    					// modifier = -1 //1 item
                        // modifier = -5;
                        // console.log('balodlasó unokatestvér');
    				} else if ( item.levelId.indexOf('SZ2T2') === 0 && item.levelId.length === 5 ) {
                        // jobb oldalsó első unokatestvér
                        modifier = 1 + this.getSs2t1Number()/2; //1 item
    				}else if (item.levelId.indexOf('SZ2T') === 0 && item.levelId.length === 5) {
                        // jobb oldalsó unokatestvér
                        // var number:number = parseInt(item.levelId.replace('SZ2T', ''));
                        // if (  number > 1 ) {
                        //     modifier = this.getTreeItemNumber( 'SZ1T' + (number-1) )/2 -1;
                        // }
                        // FIXME: unokatestvéreknél a gyerekeketis el kell tolni
                    }
    			}
            }
			var pos : number = lastXPosition + lastWidth / 2 + itemNumber / 2 + modifier;
			// console.log('itemName', item.lastName + ' ' + item.firstName, 'levelIndex', item.levelIndex, 'index', index, 'sz1tLength', this.getTreeItemNumber('SZ1T2'));
			// console.log('lastXPosition', lastXPosition, 'lastWidth/2', lastWidth / 2, 'itemNumber/2', itemNumber / 2, 'modifier', modifier, item.lastName + ' ' + item.firstName, 'levelIndex', item.levelIndex);
            // console.log('x', (pos * this.boxvHorisontalDistance) );
            // console.log('--------------------------------------------------------------');
            xPos = startX + pos * this.boxvHorisontalDistance;
			this.current_map.item[name].x            = xPos;
            console.log(item.lastName, item.firstName, this.current_map.item[name].x);
            if ( item.levelId !== null ) {
               if (item.levelId.indexOf('SZ1T2') === 0 ){
                  this.modifierNextItem = 1; //1 item
               }
            }else{
               this.modifierNextItem = 0;
            }
            var y:number = startY;
            if ( this.thisIsCouple(item) === false ) {
                //csak a főtag számít
                this.lastXPosition = pos;
                this.lastWidth = itemNumber;
            }else{
                //coupley y positon will be calc after rendered
            }
			if ( item.levelIndex !== 0 ) {
				this.current_map.item[name].y        = y + ( this.boxvVerticalDistance * item.levelIndex);
			}else{
				this.current_map.item[name].y        = y;
			}
			// new events
			this.current_map.item[name].on("rollover", (evt) => {
				var t:User = evt.target;
				if ( this.ground.contains(t) ) {
					var index = this.ground.getChildIndex(t);
					this.ground.removeChildAt(index);
					this.ground.addChild(t);
				}
			});

			this.current_map.item[name].on("rollout", (evt) => {
				var t:User = evt.target;
				this.stageDragEnabled = true;
			});

			this.ground.addChild(this.current_map.item[name]);
			this.addedIdsInStage.push(id);
		}

		// this.calcPositions(this.current_map.item[name]); áthelyezve
		this.stage.update();
        if ( returnX === true ) {
            return xPos;
        }
    }

    private getSs2t1Number():number{
        var t1:number = this.getTreeItemNumber('T1');
        var t2:number = this.getTreeItemNumber('T2');
        if ( t1 > 1 ) {
            -- t1;
        }
        if ( t2 > 1 ) {
            -- t2;
        }
        return t1 + t2;
    }

	protected findUser(id:number|Array<number>, cb:Function):void{
		if ( typeof id !== "number" ) {
			var ids:Array<number> = id;
			for (var key in ids) {
				var currentId = ids[key];
				if ( currentId > 0 ) {
					for (var ikey in this.map.layers) {
						var item = this.map.layers[ikey];
						if ( item !== undefined && item.id !== undefined && item.id === currentId ) {
							this.map.layers[ikey] = cb(item);
							break;
						}
					}
				}
			}
		}else{
			if ( id > 0 ) {
				for (var okey in this.map.layers) {
					var oitem = this.map.layers[okey];
					if ( oitem !== undefined && oitem.id !== undefined && oitem.id === id ) {
						this.map.layers[okey] = cb(oitem);
						return;
					}
				}
			}
		}
	}

    private isCousine(current:User):boolean{ //unokatestévr
        if ( current.levelId !== null && (
                ( current.levelId.indexOf('SZ1T') === 0 && current.levelId.indexOf('SZ1T1') === -1  )
                || ( current.levelId.indexOf('SZ2T') === 0 && current.levelId.indexOf('SZ2T1') === -1  )
            )) {
            return true;
        }
        return false;
    }

	protected modifCouplePostion(current){
        console.log(current.fullName, current.levelIndex);
		if ( current.levelIndex >= 0 || this.isCousine(current) ) {
			var couplesIds = current.couplesIds;
			if ( couplesIds !== null && couplesIds.length >0 ) {
				this.findUserInStage(couplesIds, (coupleItem)=>{
                    if ( coupleItem.otherFamily === true ) {
                        coupleItem.x = current.x + 20;
                        coupleItem.y = current.y + 20;
                        console.log('moved', current.fullName, coupleItem.x, coupleItem.y);
                    }else{
                        console.log('up', coupleItem.fullName, coupleItem.otherFamily);
                        this.ground.zIndexUp(coupleItem.name);
                    }
					return coupleItem;
				})
			}
		}
	}
	// protected zindexUpWhenOwenFamily(current){
	// 	if ( current.levelIndex >= 0) {
	// 		var couplesIds = current.couplesIds;
	// 		if ( couplesIds !== null && couplesIds.length >0 ) {
	// 			this.findUserInStage(couplesIds, (coupleItem)=>{
    //                 if ( coupleItem.otherFamily === true ) {
    //                     console.log(coupleItem.lastName, coupleItem.otherFamily);
    //                 }else{
    //                     console.log('up', coupleItem.fullName, coupleItem.otherFamily);
    //                     this.ground.zIndexUp(coupleItem.name);
    //                 }
	// 				return coupleItem;
	// 			})
	// 		}
	// 	}
	// }

    protected thisIsCouple(current):boolean{
        if ( current.levelIndex >= 0) {
			var couplesIds = current.couplesIds;
			if ( couplesIds !== null && couplesIds.length >0 ) {
				this.findUserInStage(couplesIds, (coupleItem)=>{
                    if ( coupleItem.otherFamily === true ) {
                        return true;
                    }
					return coupleItem;
				})
			}
		}
        return false;
    }

	private addAllParentLine(current){
		if ( current.fatherId !== null || current.motherId !== null ) {
			var father = null;
			this.findUserInStage(current.fatherId, (otherParentUser)=>{
				father = otherParentUser;
				return otherParentUser;
			});
			var mother = null;
			this.findUserInStage(current.motherId, (otherParentUser)=>{
				mother = otherParentUser;
				return otherParentUser;
			});

			if ( mother !== null && father !== null ) {
				this.addParentLine(father, mother);
			}else{
                if ( mother !== null ) {
                    this.addSingleParentLine(mother);
                }
                if ( father !== null ) {
                    this.addSingleParentLine(father);
                }
            }
		}
	}

	protected calcPositions(current : User | any, step : string) : boolean {
        var currentGroup:Array<User> = null;
		if ( step === 'calcPositions' ) {
			currentGroup = [ current ];
			this.findUserInStage(current.allBrothers, (item)=>{
				currentGroup.push(item);
				return item;
			});
			this.setChildrensPositions(current, currentGroup);
			this.modifCouplePostion(current);
            return false;
		}else if ( step === 'reCalcPositionsWhenExsist' ) {
            // reposition
            if ( this.iskExsistPlace(current.id_key, current.x, current.y) === true ) {
                var parents:Array<number> = [];
                if ( current.fatherId !== null ) {
                    parents.push( current.fatherId );
                }
                if ( current.motherId !== null ) {
                    parents.push( current.motherId );
                }
                if (  parents.length > 0 ) {
                    this.findUserInStage(parents, (item)=>{
                        item.x -= this.boxvHorisontalDistance;
                        return item;
                    });
                    // run simple calc positions
                    currentGroup = [ current ];
                    this.findUserInStage(current.allBrothers, (item)=>{
                        currentGroup.push(item);
                        return item;
                    });
                    this.setChildrensPositions(current, currentGroup);
                    this.modifCouplePostion(current);
                    return true;
                }else{
                    console.log("couldn't set new position, becaulse don't have parents");
                    return false;
                }

            }
            return false;
        }else if ( step === 'addLines' ) {
			//add lines
			var allBrothers:Array<User> = [];
			this.findUserInStage(current.allBrothers, (item)=>{
				allBrothers.push(item);
				return item;
			});
			for (var key in allBrothers) {
			    var item = allBrothers[key];
				this.addBrotherLine(current,  item);
			}
			// this.modifCouplePostion(current);
			this.addAllParentLine(current);
			this.refreshBtns(current);
            return false;
		}
	}

	public refreshBtns(item:User):void{
		//update events
		item.removeAllBtns();
		if ( item.fatherId !== null || item.motherId !== null) {
			this.addLineIfHasFatherOrMother(item);
		}
		if ( item.childrensIds.length > 0) {
			if ( item.childrensIds.length === 1 ) {
				if ( this.isHaveCouple(item) ) {
					this.removParentLienBottom('partnerLine_half' + item.id_key, 'partnerLine_half' + item.id_key);
				}else{
					this.addParentLineBottom('partnerLine_half' + item.id_key, 'partnerLine_half' + item.id_key, item.x + item.width/2,  item.y + item.height, item, -item.height/2);
				}
			}
		}
	}

	protected isHaveCouple(item:User):boolean{
		if ( item.couplesIds !== null && item.couplesIds.length > 0) {
			return true;
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./components/family_tree/Family.ts